__turbopack_context__.v({
  "backdrop": "MainCard-module-sass-module__F5gwMG__backdrop",
  "backdrop-wrap": "MainCard-module-sass-module__F5gwMG__backdrop-wrap",
  "card": "MainCard-module-sass-module__F5gwMG__card",
  "chevron": "MainCard-module-sass-module__F5gwMG__chevron",
  "content": "MainCard-module-sass-module__F5gwMG__content",
  "img-wrapper": "MainCard-module-sass-module__F5gwMG__img-wrapper",
});
